/**
 * Created by r4zi4l on 09.02.2021
 */

const Map2dAdviceHarvestLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceHarvestLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceHarvestLogic.prototype.constructor = Map2dAdviceHarvestLogic;

Map2dAdviceHarvestLogic.prototype.findMove = function () {
    const units = this.listAvailableUnits().filter((unit) => unit.getData().collectible || unit.getData().resourceCollectible || unit.getData().tank || unit.getData().feedable, this);

    if (units.length) {
        const tank = units[0].findComponent(Tank);
        if (tank && tank.amount === 0) {
            return undefined;
        }
        const cells = units.map((unit) => cc.p(unit.x, unit.y));
        return {
            cells,
            arrow: cells[0],
            highlight: cells
        };
    }
};
